/**
 * Created by Jerker Nord on 2020-01-13.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedGameData} from "../server/data/BonusBunniesParsedGameData";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";

export class BonusBunniesLayerController {

    private _extraReelEnabled:boolean = false;
    private _extraRowEnabled:boolean = false;
    private _orientation:Orientation;
    private _currentMode:string;
    private _nextMode:string;
    private static SCALE_AMOUNT_EXTRA_ROW:number = 0.8;
    private static SCALE_AMOUNT_EXTRA_REEL:number = 0.9;
    private static Y_POS_EXTRA_ROW_OFFSET:number = 16;
    private static Y_POS_EXTRA_REEL_OFFSET:number = 10;
    private static X_POS_EXTRA_ROW_OFFSET:number = 70;
    private static X_POS_EXTRA_REEL_OFFSET:number = -40;
    private static X_POS_EXTRA_REEL_ROW_OFFSET:number = 8;

    constructor() {
        this.addEventListeners();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, (event:GameEvent) => this.onResize(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        //If restore and Bonus game, check for extra reel/row and set correct scaling/positioning of layers.
        if(data.mode == BonusBunniesGameMode.BONUS_GAME && data.isRestoreState == true) {
            if(data.bottomRowActivated == true && data.lastReelActivated == false) {
                this._extraRowEnabled = true;
                this.setLayersExtraRowEnabled();
            }
            if(data.bottomRowActivated == false && data.lastReelActivated == true) {
                this._extraReelEnabled = true;
                this.setLayersExtraReelEnabled();
            }
        }
    }

    private onGameDataParsed(data:BonusBunniesParsedGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
        if(this._currentMode == BonusBunniesGameMode.BONUS_GAME) {
            if(this._extraRowEnabled == true && this._extraReelEnabled == false) {
                this.setLayersExtraRowEnabled();
            }
            if(this._extraRowEnabled == false && this._extraReelEnabled == true) {
                this.setLayersExtraReelEnabled();
            }
        }
    }

    public setLayersExtraReelEnabled():void {
        StageManager.getLayer("reelAttention").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("reelAttention").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("reelBackground").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("reelBackground").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("symbols").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("symbols").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("bonusFeature").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("bonusFeature").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("bonusSymbolValue").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("bonusSymbolValue").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("baseFeature").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("baseFeature").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("winPresentations").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("winPresentations").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
        StageManager.getLayer("betLines").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL);
        StageManager.getLayer("betLines").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET);
    }

    public setLayersExtraRowEnabled():void {
        StageManager.getLayer("reelAttention").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("reelAttention").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("reelBackground").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("reelBackground").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("symbols").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("symbols").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("bonusFeature").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("bonusFeature").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("bonusSymbolValue").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("bonusSymbolValue").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("baseFeature").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("baseFeature").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("winPresentations").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("winPresentations").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("betLines").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("betLines").position.set(BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
    }

    public setLayersExtraReelRowEnabled():void {
        StageManager.getLayer("reelAttention").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("reelAttention").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("reelBackground").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("reelBackground").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("symbols").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("symbols").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("bonusFeature").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("bonusFeature").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("bonusSymbolValue").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("bonusSymbolValue").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("baseFeature").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("baseFeature").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("winPresentations").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("winPresentations").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
        StageManager.getLayer("betLines").scale.set(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW);
        StageManager.getLayer("betLines").position.set(BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET);
    }

    private animate(scaleAmount:number, yOffset:number, xOffset:number):void {
        const attentionTL:TimelineLite = new TimelineLite();
        attentionTL.add([
            new TweenLite(StageManager.getLayer("reelAttention").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("reelAttention").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("reelBackground").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("reelBackground").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("symbols").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("symbols").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("bonusSymbolValue").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("bonusSymbolValue").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("baseFeature").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("baseFeature").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("winPresentations").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeNone
            }),
            new TweenLite(StageManager.getLayer("winPresentations").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("betLines").scale, 1, {
                x : scaleAmount,
                y : scaleAmount,
                ease : Linear.easeOut
            }),
            new TweenLite(StageManager.getLayer("betLines").position, 1, {
                y : yOffset,
                x : xOffset,
                ease : Linear.easeOut
            })
        ]);
    }

    public animateExtraRow():void {
        this.animate(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.X_POS_EXTRA_ROW_OFFSET);
        this._extraRowEnabled = true;
    }

    public animateExtraReel():void {
        this.animate(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_REEL, BonusBunniesLayerController.Y_POS_EXTRA_REEL_OFFSET, BonusBunniesLayerController.X_POS_EXTRA_REEL_OFFSET);
        this._extraReelEnabled = true;
    }

    public animateExtraReelRowZoom():void {
        this.animate(BonusBunniesLayerController.SCALE_AMOUNT_EXTRA_ROW, BonusBunniesLayerController.Y_POS_EXTRA_ROW_OFFSET, BonusBunniesLayerController.X_POS_EXTRA_REEL_ROW_OFFSET);
        this._extraReelEnabled = true;
        this._extraRowEnabled = true;
    }


    public restoreZoom():void {
        StageManager.getLayer("reelAttention").scale.set(1, 1);
        StageManager.getLayer("reelAttention").position.set(0, 0);
        StageManager.getLayer("reelBackground").scale.set(1, 1);
        StageManager.getLayer("reelBackground").position.set(0, 0);
        StageManager.getLayer("symbols").scale.set(1, 1);
        StageManager.getLayer("symbols").position.set(0, 0);
        StageManager.getLayer("bonusFeature").scale.set(1, 1);
        StageManager.getLayer("bonusFeature").position.set(0, 0);
        StageManager.getLayer("baseFeature").scale.set(1, 1);
        StageManager.getLayer("baseFeature").position.set(0, 0);
        StageManager.getLayer("bonusSymbolValue").scale.set(1, 1);
        StageManager.getLayer("bonusSymbolValue").position.set(0, 0);
        StageManager.getLayer("winPresentations").scale.set(1, 1);
        StageManager.getLayer("winPresentations").position.set(0, 0);
        StageManager.getLayer("betLines").scale.set(1, 1);
        StageManager.getLayer("betLines").position.set(0, 0);
        this._extraReelEnabled = false;
        this._extraRowEnabled = false;
    }
}